<template>
  <div class="embed">
    <!-- id 変更時に Tweet を再マウントして埋め込みを再描画する（widgets.js は prop 変更で再フェッチしないため）。 -->
    <Tweet
      :key="id"
      :id="id"
      error-message="&lt;div style='padding: 8px 16px; margin: 8px 0; line-height: 20px; border-style: solid; border-width: 1px; border-radius: 4px'&gt;このポストは読み込めませんでした。&lt;br /&gt;アカウントが非公開になっている、またはポストが削除された可能性があります。&lt;/div&gt;"
      error-message-class="message-warning"
    ></Tweet>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Tweet } from 'vue-tweet-embed'

export default defineComponent({
  props: {
    id: String
  },
  components: {
    Tweet
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.message-warning {
  color: $warning-color;
  border-color: $warning-color;
}
</style>
